import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database"; 
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDxx54ACsIQ2Fbu9-JG-NbG8tlcIbyadiQ",
  authDomain: "pet-boarding-c6fc4.firebaseapp.com",
  projectId: "pet-boarding-c6fc4",
  storageBucket: "pet-boarding-c6fc4.firebasestorage.app",
  messagingSenderId: "894745622073",
  appId: "1:894745622073:web:adeb4af397b8e3c65bbfe8",
  measurementId: "G-7R92ZQGVHR",
  databaseURL: "https://pet-boarding-c6fc4-default-rtdb.firebaseio.com" 
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// 3. Export the database so App.js can use it
export const db = getDatabase(app);
export const auth = getAuth(app);